import {
  URL_LOGIN_MICROSOFT,
  URL_GENERATE_TOKEN_DYNAMIC,
  URL_GENERATE_TOKEN_STATIC,
  URL_GENERATE_TOKEN_STATIC_SAMPLE,
  URL_GENERATE_TOKEN_DASHBOARD_ANALYTICS,
  GET_REPORT_PARAM,
  GET_REPORT_MAPPING,
  GET_PARAM_POWER_BY,
  GET_REPORT_FLEET,
  EXPORT_REPORT,
  GET_EXPORT_HISTORY,
  EXPORT_REPORT_V2,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'

export const getExportHistory = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  let param = REPO.bikinParam(body)

  return axios.get(GET_EXPORT_HISTORY + '?' + param, config_token)
}

export const exportSender = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(EXPORT_REPORT, data, config_token)
}

export const exportSenderV2 = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  return axios.post(`${EXPORT_REPORT_V2}`, data, config_token)
}

export const loginMicrosoft = (data) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }
  return axios.post(URL_LOGIN_MICROSOFT, data, config_token)
}
export const getAccessToken = (data, token) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }
  return axios.post(URL_GENERATE_TOKEN_STATIC, data, config_token)
}
export const getAccessTokenSample = (data, token, url) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }
  return axios.post(url, data, config_token)
}
export const getAccessTokenAnalytics = (data, token, url) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }
  return axios.post(url, data, config_token)
}

export const getReportParamList = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(GET_REPORT_PARAM, config_token)
}

export const postReportParam = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(GET_REPORT_PARAM, data, config_token)
}
export const updateReportParam = (id, data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(GET_REPORT_PARAM + '/' + id, data, config_token)
}
export const getReportMappingList = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  let param = REPO.bikinParam(body)
  return axios.get(GET_REPORT_MAPPING + '?' + param, config_token)
}
export const getReportMappingByFleet = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(GET_REPORT_MAPPING + '?fleet_group_id=' + id, config_token)
}

export const postReportMapping = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(GET_REPORT_MAPPING, data, config_token)
}
export const updateReportMapping = (id, data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(GET_REPORT_MAPPING + '/' + id, data, config_token)
}

export const deleteReportMapping = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(GET_REPORT_MAPPING + '/' + id, config_token)
}

export const getParserPowerBI = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(GET_PARAM_POWER_BY)
}

export const getFleetListReport = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(GET_REPORT_FLEET, config_token)
}
